import styles from "./index.module.css";
import { useEffect, useRef } from "react";
const ManAndFish = (props) => {
  const svgRef = useRef(null);
  useEffect(() => {
    svgRef.current.querySelectorAll("path").forEach((element) => {
        element.style.setProperty("--effect-path-length", `${element.getTotalLength()}px`);
    });
  }, []);
  return (
    <svg
      ref={svgRef}
      width="1056"
      height="196"
      viewBox="0 0 1056 196"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${styles.svg} ${props.className}`}
    >
      <path
        d="M2.5 146.499C41.5 137 173.725 65.8372 211.5 29.9998C250.5 -7.00025 173 94.9998 139 159.5C118.06 199.224 242 70.0002 298.5 18.5002C326.963 -7.44398 221 153 205.5 193.499"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M316.999 94.5005C303 92.5006 283.494 98.2898 278.5 111.001C273 125.001 307 108.502 322 90.5009C341.711 66.8463 317.82 99.0042 317.5 110.5C316.999 128.5 349.75 110.5 359.5 92.4997C366 80.4997 329 132.5 341.5 122C362.644 104.239 399.872 79.1758 382.5 115.5C371.5 138.5 408 119 426 108.5"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M605.499 97.999C549.5 182 438 202.501 489.5 137C529.102 86.6315 563.723 75.6592 582 44.499C597.935 17.3298 563.884 16.3392 549.5 48C532.689 85 562.5 165.5 589.5 168"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M696.5 54.4983C745.5 39.4998 863.5 13.5001 962 17.5"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M833 14.5C812.5 41.5 732 165 719.5 192"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M734 99.0003C770 95.5002 831 93 861 95.5002"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M923 67C920.5 69 918 71.5 916 75"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M908 85.999C902.5 92.999 870.5 140.999 928.5 107.999C932 89.4991 968.5 78 952 101.499C949.389 105.218 958.5 92.5005 954.5 89.5005C949.84 86.0052 929 98.5009 931 106.501C933.5 116.501 953.042 121.901 938 132.001C903 155.501 888 136.001 981 109.001C999.833 80.5005 1027 35.0001 1051 5.50014C1064.63 -11.2496 1022.5 36.4992 971 130C959.456 150.958 1030.5 66.5003 1023.5 100.001C1016.31 134.428 1033.5 117.5 1052 106.501"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
    </svg>
  );
};

export default ManAndFish;
